import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchGifts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/gift_vouchers/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchGift(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/gift_vouchers/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editGift(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/gift_vouchers", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteGift(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/gift_vouchers", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
   
  }
};
